module.exports = __webpack_public_path__ + "static/media/react-native.99cbeed9.jpg";